/**
 * DetailContent section.
 */
import Container from '@components/atoms/container/contentContainer';
import Event from '@components/sections/detail/detailEvent';
import Metadata from '@components/sections/detail/detailMetadata';
import Related from '@components/elements/detail/detailRelated';
import VerticalAnimation from '@components/atoms/container/verticalAnimationContainer';
import useDetailContent from '@components/sections/detail/useDetailContent';

/**
 * Renders the detail content section. Includes the event information, metadata, and related content.
 */
export default function DetailContent() {
  const { props } = useDetailContent();
  return (
    <Container {...props.container}>
      <VerticalAnimation {...props.animation}>
        <Event />
        <Metadata />
        <Related />
      </VerticalAnimation>
    </Container>
  );
}
